import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonServicesProvider } from './common.services';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private appConfigSubject = new BehaviorSubject<any>(null);
  appConfig$ = this.appConfigSubject.asObservable(); // subscribe anywhere

  constructor(
    public serviceProvider: CommonServicesProvider,
  ) { }

  loadConfig() {
    const appconfigurl = "api/aichatbot/fetchAppConfig";
    return new Promise((resolve, reject) => {
      this.serviceProvider.withoutpostData(appconfigurl, {})
        .subscribe({
          next: (res: any) => {
            const config = res?.data?.[0] || {};
            this.appConfigSubject.next(config);
            resolve(config);
          },
          error: (err) => {
            console.error('❌ Config load error:', err);
            reject(err);
          }
        });
    });
  }

  getConfigSync() {
    return this.appConfigSubject.value; // quick access without subscribe
  }
}
